import {
    Row,
    Col
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import { addSetting, getSetting, updateSetting, deleteSettings, addAddress } from "../services/settingServices";
import { getOneAccount } from "../services/accountService";

// import utils from "../../../utils/utils";
import FullLayout from '../layouts/FullLayout';

// import Pagination from "../../../components/Pagination";
import Toast from 'react-bootstrap/Toast';
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";
import { useState, useEffect, useContext } from "react";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
// import DeleteModal from "../../../components/DeleteModal";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { getFile } from "../utils/utils";


export default function Settings() {

    const [label, setLabel] = useState('')
    const [value, setValue] = useState('')
    const [key, setKey] = useState('')

    const [address, setAddress] = useState('')
    const [image, setImage] = useState<File | null>(null);

    const [preview, setPreview] = useState<string | null>(null); // Store preview URL

    const [labelError, setlabelError] = useState('')
    const [valueError, setValueError] = useState('')
    const [keyError, setkeyError] = useState('')
    const [addressError, setAddressError] = useState('')


    const [deleteId, setDeleteId] = useState(null);
    const [copy, setCopy] = useState([]);

    const [settingDetails, setsettingDetails] = useState([])
    const [loading, setLoading] = useState(false);
    const [showDelete, setShowDelete] = useState(false);


    // let { id } = useParams();

    const toast: any = useContext(AlertContext);

    // console.log("toast", toast)

    useEffect(() => {
        fetchSettingPage();
        getOneUserAddress()
    }, []);
    //get one
    const getOneUserAddress = async () => {
        try {
            const response = await getOneAccount();
            if (response?.status === 200) {
                const responseData = response?.data?.data;
                console.log('responseData', responseData)
                setAddress(responseData.QRcode);
                if (responseData.QRImage) {
                    setImage(responseData.QRImage); // Set the image URL
                    setPreview(getFile(responseData.QRImage)); // Set preview to display the image
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
    //get
    async function fetchSettingPage() {
        try {
            setLoading(true);
            const response = await getSetting();

            const responseData = response?.data;

            if (response.status === 200) {
                setsettingDetails(responseData?.data);
                setCopy(responseData?.data);
                // const pages = utils.decidePages(responseData.count);
                // setPages(pages);
                console.log('response', response)
            } else {
                // toast.setToast("Internal Server error!", "danger");
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Error:", error);
            // toast.setToast("Internal Server error!", "danger");
        }
    }

    //post
    const handleSubmit = async (event: any) => {
        event.preventDefault()

        if (label === '') {
            setlabelError('Label Required*')
            return false
        }
        if (value === '') {
            setValueError('value Required*')
            return false
        }
        if (key === '') {
            setkeyError('key Required*')
            return false
        }

        try {
            // setLoading(true);

            const response = await addSetting(label, value, key);
            const responseData = response?.data;
            console.log("response", responseData)
            let theme = "success";

            if (response?.status === 200) {
                // navigate(`/${role}/categories`)
                console.log("response", response)

                setLabel('')
                setValue('')
                setKey('')

                fetchSettingPage()

            } else {
                console.log("error", response)
                theme = "danger"
            }
            // setLoading(false);
            window.scrollTo(0, 0);
            toast.setToast(responseData.data, theme);
            // toast.setToast(responseData?.data, theme);
            console.log("responseData?.data", responseData?.data)
        } catch (error) {
            // setLoading(false);
            console.error("Error:", error);
        }
    }

    const handleAdminAddressSetting = async (event: any) => {
        event.preventDefault()

        if (address === '') {
            setAddressError('Address Required*')
            return false
        }

        try {
            // const formData: any = {};
            const formData = new FormData();
            formData.append("address", address);
            if (image) {
                formData.append("bannerImage", image); // Make sure the field name matches the backend
            }


            const response = await addAddress(formData);
            const responseData = response?.data;
            console.log("response", responseData)
            let theme = "success";

            if (response?.status === 200) {
                // navigate(`/${role}/categories`)
                console.log("response", response)

                // setAddress('')
                // fetchSettingPage()

            } else {
                console.log("error", response)
                theme = "danger"
            }
            // setLoading(false);
            window.scrollTo(0, 0);
            toast.setToast(responseData.message, theme);
            // toast.setToast(responseData?.data, theme);
            console.log("responseData?.data", responseData?.data)
        } catch (error) {
            // setLoading(false);
            console.error("Error:", error);
        }
    }
    const handleChangeAddress = (event: any) => {
        setAddress(event.target.value)
        if (address !== "") {
            setAddressError("")
        }
    }

    const handleImage = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            setImage(file);
            setPreview(URL.createObjectURL(file)); // Generate preview URL
        }
    };

    const handleChangeLabel = (event: any) => {
        setLabel(event.target.value)
        if (label !== "") {
            setlabelError("")
        }
    }
    const handleChangeValue = (event: any) => {
        setValue(event.target.value)
        if (value !== "") {
            setValueError("")

        }
    }
    const handleChangeKey = (event: any) => {
        setKey(event.target.value)
        if (keyError !== "") {
            setkeyError("")
        }
    }

    //update
    async function handleUpdate() {
        const arr: any = [];
        settingDetails.forEach((item: any) => {
            const obj = {
                id: item.id,
                value: item.value
            }
            arr.push(obj);
            // const response = await updateSetting(item.id, item.settingsValue);
        });
        const response = await updateSetting(arr);
        const responseData = response.data
        let theme = "success";
        if (response.status === 200) {
            // toast.setToast("Setting updated successfully!", "success")
        } else {
            // toast.setToast("Something went wrong on our side. Please try again later!", "danger")
            theme = "danger"
        }
        window.scrollTo(0, 0);
        toast.setToast(responseData.data, theme);
    }


    function handleEditChange(e: any) {
        const { id, value } = e.target;
        setsettingDetails((prevState: any) => (prevState.map((item: any) => {
            const itemCopy = { ...item };
            if (item.id == id) {
                itemCopy.value = value;
            }
            return itemCopy;
        })))
    }


    //delete
    // async function handleDelete() {
    //     try {
    //         const response = await deleteSettings(deleteId);

    //         const responseData = response?.data;
    //         let theme = "success";
    //         if (response?.status === 200) {
    //             fetchSettingPage();
    //             setShowDelete(false);

    //         } else {
    //             console.log("error", response)
    //             theme = "danger"
    //         }
    //         window.scrollTo(0, 0);
    //         // toast.setToast(responseData?.data, theme);
    //     } catch (error) {
    //         console.error("Error:", error);
    //     }
    // }
    async function handleDelete() {
        try {
            if (!deleteId) return; // Ensure an ID is selected

            const response = await deleteSettings(deleteId);
            const responseData = response.data
            let theme = "success";
            if (response?.status === 200) {
                fetchSettingPage(); // Refresh settings list
                setShowDelete(false); // Close modal
                setDeleteId(null); // Clear selected ID
            } else {
                console.log("Delete error:", response);
                theme = 'danger'
            }
            window.scrollTo(0, 0);
            toast.setToast(responseData.data, theme);
        } catch (error) {
            console.error("Error deleting setting:", error);
        }
    }
    const handleSearch = (e: any) => {
        const searchInput = e.target.value.toLowerCase();
        const filteredData = copy.filter(item =>
            Object.values(item).some(val => String(val).toLowerCase().includes(searchInput))
        );
        setsettingDetails(filteredData);
    }


    return (
        <FullLayout
        >

            <Row>
                <div className="panel_top_section">
                    <h1>Settings</h1>

                    <div className="grid_icons d-flex gap-3 align-items-center float-end">
                        <input type='text' placeholder='Search' className='form-control' onChange={handleSearch} />
                    </div>
                </div>
                <Col>


                    {settingDetails?.length > 0 &&
                        <div className="col-sm-12 col-xl-12 row">
                            {settingDetails?.map((item: any, index: number) => {

                                return (
                                    <div className="col-sm-6 col-xl-6 mb-2">
                                        <Form>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="basic-url" className="mt-3">{item.label}

                                                    {/* <i className="bi bi-trash p-1"
                                                        onClick={() => {
                                                            setDeleteId(item.id); // Set the ID
                                                            setShowDelete(true); // Open modal
                                                        }}
                                                    /> */}
                                                </Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" onChange={handleEditChange} value={item.value} id={item.id} />
                                                </InputGroup>

                                            </Form.Group>
                                        </Form>

                                    </div>
                                )
                            }

                            )}
                            <div>
                                <button
                                    className="btn_gradian ms-3 mt-3"
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    }


                    {/* <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url" className="mt-3">Settings label</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" className='' onChange={handleChangeLabel} value={label} />
                            </InputGroup>
                            {labelError ? <span className="text-danger">{labelError}</span> : ""}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url">Settings Default Value</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" onChange={handleChangeValue} value={value} />
                            </InputGroup>
                            {valueError ? <span className="text-danger">{valueError}</span> : ""}


                        </Form.Group>


                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url">Setting key</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" className='' onChange={handleChangeKey} value={key} />

                            </InputGroup>
                            {keyError ? <span className="text-danger">{keyError}</span> : ""}

                        </Form.Group>

                        
                        <button
                            className="btn_gradian ms-3 mt-3"
                            type="submit"
                        // onClick={handleUpdate}
                        >
                            Add
                        </button>
                    </Form> */}

                    <Form onSubmit={handleAdminAddressSetting}>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url" className="mt-3">Admin Address Settings</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" className='' onChange={handleChangeAddress} value={address} />
                            </InputGroup>
                            {addressError ? <span className="text-danger">{addressError}</span> : ""}
                        </Form.Group>

                        <Form.Group 
                        // controlId="formFile"
                         className="mb-3">
                            <Form.Label htmlFor="basic-url">Image</Form.Label>
                            <InputGroup className="mb-4">

                                <Form.Control type="file" className="p-2"
                                    // value={image}
                                    accept="image/*"
                                    onChange={handleImage} />
                            </InputGroup>
                        </Form.Group>

                        {preview && (
                            <div className="mb-3">
                                <img src={preview} alt="Preview" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                            </div>
                        )}



                        <button
                            className="btn_gradian ms-3 mt-3"
                            type="submit"
                        // onClick={handleUpdate}
                        >
                            Add
                        </button>
                    </Form>


                    {/* {loading &&
                    <tr className="list_detail">
                        <td colSpan={10}>
                            {!loading ?
                                "No data found"
                                :
                                <Spinner />
                            }
                        </td>
                    </tr>} */}
                </Col>

            </Row >
            {showDelete && (
                <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to delete this setting?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>
                            Close
                        </Button>
                        <Button variant="danger" onClick={handleDelete}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </FullLayout>
    )
}